"use client";
import React, { useEffect, useRef, useState } from "react";
// import { useNavigate, useParams } from "react-router";
import ReadMore from "@/components/ReadMore";
import WalkthroughVideo from "@/components/Walkthrough";
import "./Detail.css";
import { Swiper, SwiperSlide } from "swiper/react";
import api from "@/helper/api.interceptor";
import { useDispatch, useSelector } from "react-redux";
import {
  setAmenityToggle,
  setInquiryPopup,
  setInquiryPopupObj,
  setThankYouData,
  setProximityToggle,
} from "@/store/slices/inquirySlice";
import { usePathname, useRouter } from "next/navigation";
import { Toast } from "@/components/Toast";
import RawData from "@/data/projectList.json";
import Image from "next/image";
import Gallery from "@/components/Gallery/Gallery";
import Amenities from "@/components/Amenities/Amenities";
import Amenitiesswiper from "@/components/Amenitiesswiper/Amenitiesswiper";
import Specifications from "@/components/Specifications/Specifications";
import ConstructionUpdate from "@/components/ConstructionUpdate/ConstructionUpdate";
import ProjectHeroInfo from "@/components/ProjectHeroInfo/ProjectHeroInfo";
import WalkthroughSection from "@/components/WalkthroughSection/WalkthroughSection";
import ProjectWalkthrough from "@/components/ProjectWalkthrough/ProjectWalkthrough";
import AboutProjectSection from "@/components/AboutProjectSection/AboutProjectSection";
import ProjectHighlightsSection from "@/components/ProjectHighlightsSection/ProjectHighlightsSection";
import GalleryTaglineSection from "@/components/GalleryTaglineSection/GalleryTaglineSection";
import GalleryGrid from "@/components/GalleryGrid/GalleryGrid";
import AmenitiesSection from "@/components/AmenitiesSection/AmenitiesSection";
import NbPalmTerraceSection from "@/components/NbPalmTerraceSection/NbPalmTerraceSection";
import ConstructionUpdateNew from "@/components/ConstructionUpdateNew/ConstructionUpdateNew";
import LocationSectionNew from "@/components/LocationSectionNew/LocationSectionNew";
import InquireNowNew from "@/components/InquireNowNew/InquireNowNew";
import CertificateNew from "@/components/CertificateNew/CertificateNew";
import BottomStrip from "@/components/BottomStrip";
// import BottomStrip from "@/components/BottomStrip";
// import { Fancybox } from "@fancyapps/ui";
// import Seo from "../components/Seo";
// import { CountryList } from "../services/CountryList";
// import { ProjectInquiry } from "../services/ProjectInquiry";

export default function Detail({
  //   isAmenityOpen,
  //   setAmenityToggle,
  //   isProximityOpen,
  //   setProximityToggle,
  // inquiryPopupObj,
  // setInquiryPopupObj,
  // inquiryPopup,
  // setInquiryPopup,
  projectDetail,
  propertylist,
  completedPropertylist,
}) {
  const pathName = usePathname();
  const dispatch = useDispatch();
  const router = useRouter();

  // const [isAmenityOpen, setAmenityToggle] = useState(false);
  // const [isProximityOpen, setProximityToggle] = useState(false);
  //   const { slug } = useParams();
  //   const navigate = useNavigate();
  const [staticProjectDetail, setStaticprojectDetail] = useState(null);
  // const [seoMetaData, setseoMetaData] = useState(null);
  // const [countryList, setcountryList] = useState(null);
  const [countryFlag, setCountryFlag] = useState(false);
  const [isMobilescreen, setMobileScreen] = useState(false);
  const [activeImage, setActiveImage] = useState("");
  const [selectedTab, setSelectedTab] = useState("3bhk");
  const [showNextImages, setShowNextImages] = useState(false);
  const [search, setSearch] = useState("");
  const [formSubmitted, setFormSubmitted] = useState(false);
  const [submitLoad, setSubmitLoad] = useState(false);
  // const [seoMetaData, setSeoMetaData] = useState(null);
  console.log(projectDetail);
  const [inquiryObj, setInquiryObj] = useState({
    agree_tandc: "1",
    agree_tandc_display: true,
    client_name: "",
    client_contact_no_display: "",
    client_contact_no: "",
    email_address: "",
    from_app: "true",
    master_user_id: "632",
    logged_in_master_user_id: "632",
    remarks: "",
    inquiry_from: "web",
    user_type: "N",
    flag: "https://flagcdn.com/w40/in.webp",
    country: "91",
    project_id: "",
  });
  const [errors, setErrors] = useState({});

  const StaticData = RawData.list;

  const projectlist = StaticData.find(
    (item) => item.project_id === projectDetail.project_id,
  );
  // const initialInquiryState = {
  //   agree_tandc: "1",
  //   agree_tandc_display: true,
  //   client_name: "",
  //   client_contact_no_display: "",
  //   client_contact_no: "",
  //   email_address: "",
  //   from_app: "true",
  //   master_user_id: "632",
  //   logged_in_master_user_id: "632",
  //   remarks: "",
  //   inquiry_from: "web",
  //   user_type: "N",
  //   flag: "https://flagcdn.com/w40/in.webp",
  //   country: "91",
  //   project_id: "",
  // };

  // function inquiryReducer(state, action) {
  //   switch (action.type) {
  //     case "UPDATE_FIELD":
  //       return { ...state, [action.field]: action.value };
  //     case "RESET":
  //       return initialInquiryState;
  //     case "SET_FULL_OBJECT":
  //       return { ...state, ...action.payload };
  //     default:
  //       return state;
  //   }
  // }

  // use it inside your component
  // const [inquiryObj, dispatchInquiry] = useReducer(
  //   inquiryReducer,
  //   initialInquiryState
  // );

  const countryList = useSelector((state) => state.inquiry.countryList) || [];
  const isAmenityOpen = useSelector((state) => state.inquiry.isAmenityOpen);
  const isProximityOpen = useSelector((state) => state.inquiry.isProximityOpen);

  // ✅ Compute SEO data during render (SSR-friendly)
  //   const seoMetaData = projectDetail && {
  //     page_title: projectDetail.page_title || projectDetail.project_title,
  //     page_description: projectDetail.page_description,
  //     page_keywords: projectDetail.page_keywords,
  //     slug: projectDetail.slug,
  //     image: projectDetail.page_image_full
  //       ? projectDetail.page_image_full.includes("?")
  //         ? `${projectDetail.page_image_full}&w=1280&h=640`
  //         : `${projectDetail.page_image_full}?w=1280&h=640`
  //       : "/images/og-img.jpeg",
  //   };

  // const handleNumber = (e) => {
  //   const { name, value } = e.target;

  //   if (name == "client_contact_no_display") {
  //     const updatedValue = value.replace(/[^0-9]/g, "").slice(0, 10); // ✅ keep only numbers and limit to 10 digits
  //     setInquiryObj((prev) => ({
  //       ...prev,
  //       [name]: updatedValue,
  //     }));
  //   }
  // };
  const inquiryPopupObj = useSelector((state) => state.inquiry.inquiryPopupObj);
  const handleChange = (e) => {
    setFormSubmitted(false);
    const { name, value } = e.target;

    let updatedValue = value;

    // Prevent numbers in client_name (handle paste or typing)
    if (name === "client_name") {
      updatedValue = value.replace(/[0-9]/g, ""); // remove any digits
    }

    // For contact_no, allow only numbers
    if (name === "client_contact_no_display") {
      updatedValue = value.replace(/[^0-9]/g, ""); // remove non-numeric chars
      if (updatedValue.length > 10) {
        updatedValue = updatedValue.slice(0, 10); // limit to 10 digits
      }
    }

    // Email validation
    if (name === "email_address") {
      const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
      if (!emailRegex.test(updatedValue)) {
        setErrors((prev) => ({
          ...prev,
          email_address: "Invalid email format",
        }));
      } else {
        setErrors((prev) => ({
          ...prev,
          email_address: "",
        }));
      }
    } else {
      setErrors((prev) => ({
        ...prev,
        [name]: "",
      }));
    }

    // Update state
    setInquiryObj((prev) => ({
      ...prev,
      [name]: updatedValue,
    }));
  };

  // const handleChange = (e) => {
  //   const { name, value } = e.target;
  //   dispatchInquiry({ type: "UPDATE_FIELD", field: name, value });
  // };

  const validate = () => {
    let newErrors = {};
    const nameRegex = /^[a-zA-Z\s]+$/;
    const phoneRegex = /^\d{10}$/;
    const emailRegex = /^[\w.-]+@[a-zA-Z\d.-]+\.[a-zA-Z]{2,}$/;

    if (!inquiryObj.client_name.trim()) {
      newErrors.client_name = "Name is required";
    } else if (!nameRegex.test(inquiryObj.client_name)) {
      newErrors.client_name = "Name must contain only letters";
    }

    if (!inquiryObj.client_contact_no_display.trim()) {
      newErrors.client_contact_no_display = "Contact number is required";
    } else if (!phoneRegex.test(inquiryObj.client_contact_no_display)) {
      newErrors.client_contact_no_display = "Contact number must be 10 digits";
    }

    if (!inquiryObj.email_address.trim()) {
      newErrors.email_address = "Email is required";
    } else if (!emailRegex.test(inquiryObj.email_address)) {
      newErrors.email_address = "Invalid email format";
    }

    return newErrors;
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setFormSubmitted(true);
    const validationErrors = validate();
    if (Object.keys(validationErrors).length > 0) {
      // setFormSubmitted(false);
      setErrors(validationErrors);
    } else {
      setSubmitLoad(true);
      let project_id = projectDetail.project_id;
      let client_contact_no =
        inquiryObj.country + " " + inquiryObj.client_contact_no_display;

      const finalInquiry = {
        ...inquiryObj,
        client_contact_no,
        project_id,
      };
      // console.log("Form Data:", finalInquiry);
      let response = await api.Projectinquiry(finalInquiry);
      // console.log(projectDetail.project_title);
      if (response.success) {
        setFormSubmitted(false);
        setSubmitLoad(false);

        // navigate(`/${projectDetail.slug}/thankyou`, {
        //   state: {
        //     name: projectDetail.project_title,
        //     document: projectDetail.document_other_data
        //       ? projectDetail.document_other_data
        //       : [],
        //   },
        // });

        dispatch(
          setThankYouData({
            page_name: projectDetail.project_title,
            document: projectDetail.document_other_data
              ? projectDetail.document_other_data
              : [],
          }),
        );
        router.push(`/${projectDetail.slug}/thankyou`);

        // dispatchInquiry({ type: "RESET" });

        setInquiryObj({
          client_name: "",
          client_contact_no_display: "",
          client_contact_no: "",
          email_address: "",
          from_app: "true",
          master_user_id: "632",
          logged_in_master_user_id: "632",
          remarks: "",
          inquiry_from: "web",
          user_type: "N",
          flag: "https://flagcdn.com/w40/in.webp",
          country: "91",
          project_id: "",
        });

        Toast(response.message);
      }
    }
  };

  useEffect(() => {
    const shouldLockScroll = isAmenityOpen || isProximityOpen;
    // const shouldLockScroll = isAmenityOpen;

    document.body.style.overflow = shouldLockScroll ? "hidden" : "auto";

    if (isAmenityOpen || isProximityOpen) {
      dispatch(setInquiryPopup(false));
    }

    // console.log(isAmenityOpen);
    // console.log(isProximityOpen);

    return () => {
      document.body.style.overflow = "auto"; // cleanup on unmount
    };
    //   }, [inquiryPopup, isAmenityOpen, isProximityOpen]);
  }, [isAmenityOpen, isProximityOpen]);

  useEffect(() => {
    // let dataToUse;
    // let StaticData = {};
    // if (projectData && projectData.slug === slug) {
    //   dataToUse = projectData;
    //   StaticData = projectsArray.find(
    //     (p) => p.project_id == dataToUse.project_id
    //   );
    // } else {
    //   const allProjects = [...propertylist, ...completedPropertylist];
    //   dataToUse = allProjects.find((project) => project.slug === slug);
    //   StaticData = projectsArray.find(
    //     (p) => p.project_id == dataToUse.project_id
    //   );
    // }

    if (projectDetail) {
      let staticData = StaticData.find(
        (p) => p.project_id == projectDetail.project_id,
      );

      // console.log(staticData, "<== Here");

      if (staticData) {
        setStaticprojectDetail(staticData);
      }

      let activeImage = "";
      if (
        projectDetail.gallery_data &&
        projectDetail.gallery_data[0] &&
        projectDetail.gallery_data[0].image &&
        projectDetail.gallery_data[0].image[0] &&
        projectDetail.gallery_data[0].image[0].title
      ) {
        activeImage = projectDetail.gallery_data[0].image[0].title;
      }
      setActiveImage(activeImage);
    }
  }, [projectDetail, propertylist, completedPropertylist]);

  const handleCountrySelect = (phonecode, flag) => {
    // dispatchInquiry({
    //   type: "SET_FULL_OBJECT",
    //   payload: {
    //     country: phonecode,
    //     flag: flag,
    //   },
    // });

    setInquiryObj({
      ...inquiryObj,
      country: phonecode,
      flag: flag,
    });
    setCountryFlag(false);
  };

  const loadCountry = async () => {
    try {
      //   const data = await CountryList();
      // Filter directly, without `await`
      //   const filtered = data.filter((country) => country.phonecode !== "92");
      //   setcountryList(filtered);
    } catch (err) {
      console.error("Error loading country data:", err);
    }
  };
  useEffect(() => {
    // loadCountry();
    // let fancyboxInstance;
    if (window.innerWidth <= 767) {
      setMobileScreen(true);
    }

    // import("@fancyapps/ui").then(({ Fancybox }) => {
    //   fancyboxInstance = Fancybox.bind(
    //     "[data-fancybox=project-gallery-fancy]",
    //     {
    //       Carousel: {
    //         infinite: true,
    //       },
    //     }
    //   );

    // Fancybox.bind("[data-fancybox=project-gallery-fancy4]", {
    //   Carousel: {
    //     infinite: true,
    //   },
    // });
    // });
    return () => {
      //   import("@fancyapps/ui").then(({ Fancybox }) => {
      //     Fancybox.destroy();
      //   });
    };
  }, []);
  useEffect(() => {
    if (projectDetail) {
      console.log("🔥 Project Detail:", projectDetail);
      console.log("📌 Project ID:", projectDetail.project_id);
      console.log("🏷 Title:", projectDetail.project_title);
      console.log("🖼 Gallery:", projectDetail.gallery_data);
      console.log("🏗 Amenities:", projectDetail.amenities_data);
    }
  }, [projectDetail]);
  useEffect(() => {
    if (projectDetail) {
      // console.log(projectDetail);
      dispatch(setInquiryPopupObj(projectDetail));
    }
  }, [projectDetail, pathName]);

  // useEffect(() => {
  //   if (projectDetail) {
  //     dispatch(setInquiryPopupObj(projectDetail));
  //   }
  // }, [pathName]);

  const bottomStripRef = useRef(null);
  const floatingBtnRef = useRef(null);

  useEffect(() => {
    const handleScroll = () => {
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const documentHeight = document.body.scrollHeight;
      const remainingDistance = documentHeight - (scrollTop + windowHeight);

      const bottomStrip = bottomStripRef.current;
      const floatingBtn = floatingBtnRef.current;

      if (!bottomStrip || !floatingBtn) return;

      if (scrollTop > 600 && remainingDistance > 600) {
        bottomStrip.classList.add("showStrip");
        floatingBtn.classList.add("active");
      } else if (scrollTop < 200) {
        bottomStrip.classList.remove("showStrip");
        floatingBtn.classList.remove("active");
      } else if (remainingDistance >= 600) {
        setTimeout(() => {
          bottomStrip.classList.add("showStrip");
          floatingBtn.classList.add("active");
        }, 100);
      }

      if (remainingDistance < 600) {
        setTimeout(() => {
          bottomStrip.classList.remove("showStrip");
          floatingBtn.classList.remove("active");
        }, 100);
      }
    };

    window.addEventListener("scroll", handleScroll);
    return () => window.removeEventListener("scroll", handleScroll);
  }, []);

  const projectThemes = {
    880: {
      // NB Palm
      "--primary-color": "#0b0b0b",
      "--secondary-color": "#6E3A2F",
      "--gradientsecondary-color": "#6E3A2F",
      "--theme-gradient":
        "linear-gradient(271.27deg, #361814 1.09%, #5F2922 85.95%)",
      "--secondary-highlight-color": "#6E3A2F",
      "--background-smoke": "#F5F3F1",
      "--gray-color": "#8B817C",
      "--black-color": "#2E201D",
      "--gallery-title-color": "#E1C587",
    },

    881: {
      // NB Sarvam
      "--primary-color": "#0b0b0b",
      "--secondary-color": "#8F3F12",
      "--gradientsecondary-color": "#8F3F12",
      "--theme-gradient":
        "linear-gradient(271.27deg, #8F3F12 1.09%, #8F3F12 85.95%)",
      "--secondary-highlight-color": "#8F3F12",
      "--background-smoke": "#F7F8F8",
      "--gray-color": "#6F7477",
      "--black-color": "#0B0B0B",
      "--gallery-title-color": "#ffffff",
    },

    887: {
      // NB Parva
      "--primary-color": "#0b0b0b",
      "--secondary-color": "#154F8D",
      "--gradientsecondary-color": "#154F8D",
      "--theme-gradient":
        "linear-gradient(171.27deg, #103B69 1.09%, #1E6CC1 85.95%)",
      "--secondary-highlight-color": "#154F8D",
      "--background-smoke": "#F6F8FB",
      "--gray-color": "#6F7C8B",
      "--black-color": "#0B0B0B",
      "--gallery-title-color": "#ffffff",
    },

    888: {
      // Stark Torre
      "--primary-color": "#0b0b0b",
      "--secondary-color": "#242628",
      "--gradientsecondary-color": "#242628",
      "--theme-gradient":
        "linear-gradient(271.27deg, #373435 1.09%, #242628 85.95%)",
      "--secondary-highlight-color": "#242628",
      "--background-smoke": "#F4F4F4",
      "--gray-color": "#777777",
      "--black-color": "#1B1B1B",
      "--gallery-title-color": "#ffffff",
    },

    default: {
      "--primary-color": "#000000",
      "--secondary-color": "#001871",
      "--gradientsecondary-color": "#001871",
      "--theme-gradient":
        "linear-gradient(271.27deg, #00104D 1.09%, #0026B5 85.95%)",
      "--secondary-highlight-color": "#953b21",
      "--background-smoke": "#fafafa",
      "--gray-color": "#8e9194",
      "--black-color": "#000000",
      "--gallery-title-color": "#ffffff",
    },
  };
  const projectTheme =
    projectThemes[String(projectDetail?.project_id)] || projectThemes.default;

  if (projectDetail) {
    console.log(projectDetail.amenities_images?.[0].image);
    return (
      <>
        {/* {seoMetaData && <Seo metaData={seoMetaData} />} */}
        <BottomStrip
          // isAmenityActive={isAmenityOpen}
          // isProximityActive={isProximityOpen}
          projectTheme={projectTheme}
          isMobilescreen={isMobilescreen}
          projects_full_list_detail={inquiryPopupObj}
        />
        <div
          className="reecosys-main-wrapper reecosys-detail-wrapper"
          id="reecosys-main-wrapper"
          style={projectTheme}
          onClick={() => {
            setCountryFlag(false);
          }}
        >
          <div id="reecosys-detail-wrapper" className="relative">
            <div className="bg-gradient-theme-detail">
              <ProjectHeroInfo projectDetail={projectDetail} staticProjectDetail={staticProjectDetail} />
              {/* NB Palm custom local walkthrough */}
              {String(projectDetail?.project_id) === "880" && (
                <WalkthroughSection projectDetail={projectDetail} />
              )}

              {/* Other projects walkthrough */}
              {String(projectDetail?.project_id) !== "880" && (
                <ProjectWalkthrough projectDetail={projectDetail} />
              )}
              <AboutProjectSection
                projectDetail={projectDetail}
                dispatch={dispatch}
                setInquiryPopup={setInquiryPopup}
                setInquiryPopupObj={setInquiryPopupObj}
                isMobilescreen={isMobilescreen}
              />
            </div>
            {projectDetail?.highlights?.length > 0 && (
              <ProjectHighlightsSection projectDetail={projectDetail} />
            )}

            <div className="bg-gradient-thing">
              <GalleryTaglineSection projectDetail={projectDetail} />
              {projectDetail?.gallery_data?.[0]?.image?.length > 0 && (
                <GalleryGrid images={projectDetail.gallery_data[0].image} />
              )}
              <AmenitiesSection projectDetail={projectDetail} />
            </div>

            <NbPalmTerraceSection projectDetail={projectDetail} />
            {projectDetail?.construction_data?.image?.length > 0 && (
              <ConstructionUpdateNew projectDetail={projectDetail} />
            )}

            <LocationSectionNew
              projectDetail={projectDetail}
              dispatch={dispatch}
              setProximityToggle={setProximityToggle}
              staticProjectDetail={staticProjectDetail}
            />
            <InquireNowNew
              handleSubmit={handleSubmit}
              inquiryObj={inquiryObj}
              handleChange={handleChange}
              errors={errors}
              formSubmitted={formSubmitted}
              submitLoad={submitLoad}
              countryFlag={countryFlag}
              setCountryFlag={setCountryFlag}
              countryList={countryList}
              search={search}
              setSearch={setSearch}
              handleCountrySelect={handleCountrySelect}
              projectId={projectDetail?.project_id}
            />

            <CertificateNew projectDetail={projectDetail}/>
            {/* {
              // projectDetail.big_text_pain &&
              (projectDetail.highlights?.length > 0 ||
                projectDetail.rera_number != undefined ||
                projectDetail.document_data != undefined ||
                projectDetail.big_text_pain != undefined) && (
                <section
                  className="reecosys-section relative section-padding"
                  id="reecosys-project-detail-section-3"
                >
                  <div className="main-container detail-highlight-wrapper">
                    <div className=" inner-flex inner-flex-small2">
                      <div className="inner-flex inner-flex-smallest">
                        {projectDetail.project_title && (
                          <div className="banner-title banner-title-border-div relative">
                            <h2
                              className=" uppercase"
                              dangerouslySetInnerHTML={{
                                __html: projectDetail.project_title,
                              }}
                            ></h2>
                            <div
                              className={`detail-status-lable status-lable status-${projectDetail.status
                                .toLowerCase()
                                .replace(/\s+/g, "-")
                                .replace(/[^a-z0-9-]/g, "")}`}
                            >
                              <p className="text-uppercase">
                                {projectDetail.status}
                              </p>
                            </div>
                          </div>
                        )}
                      </div>

                      <div className="new-detail-banner-abs-flex">
                        <div className="inner-flex inner-flex-smallest">
                          <div className="new-detail-highlight-grid">
                            {projectDetail.big_text_pain && (
                              <div className=" section-paragraph readmoreText detailReadMore">
                                <p
                                  dangerouslySetInnerHTML={{
                                    __html: projectDetail.big_text_pain,
                                  }}
                                >
                                </p>
                              </div>
                            )}
                            {projectDetail.highlights != undefined &&
                              projectDetail.highlights.length > 0 &&
                              projectDetail.highlights.map((data, index) => (
                                <div key={index}>
                                  <div className="section-paragraph">
                                    <p className="capitalize  semibold-fonts">
                                      {data.tag_line}
                                    </p>
                                  </div>
                                  <div className="section-paragraph">
                                    <p className="capitalize gray-color regular-fonts">
                                      {data.name}
                                    </p>
                                  </div>
                                </div>
                              ))}
                            {projectDetail.rera_number && (
                              <div
                                style={{ flexBasis: "100%", opacity: "0.4" }}
                              >
                                <div className="section-paragraph">
                                  <p>
                                    <span className="primary-color bold-fonts">
                                      RERA :
                                    </span>
                                    {projectDetail.rera_number}
                                  </p>
                                </div>
                              </div>
                            )}
                          </div>
                        </div>
                      </div>

                      <div className="">
                        <ul className="flex-row  downloadDataFlex">
                          <li>
                            <button
                              className={`reecosys-template-button button-style-secondary w100`}
                              onClick={() => {
                                (dispatch(setInquiryPopupObj(projectDetail)),
                                  dispatch(setInquiryPopup(true)));
                              }}
                            >
                              <span className="material-symbols-outlined">
                                chat
                              </span>
                              <p className="capitalize">Inquire Now</p>
                            </button>
                          </li>
                          {projectDetail.document_other_data != undefined &&
                            projectDetail.document_other_data.length > 0 &&
                            projectDetail.document_other_data
                              .filter(
                                (download_data) =>
                                  download_data.type == "Brochure",
                              )
                              .map((download_data, index) => (
                                <li key={index}>
                                  <button
                                    onClick={() => {
                                      (dispatch(
                                        setInquiryPopupObj(projectDetail),
                                      ),
                                        dispatch(setInquiryPopup(true)));
                                    }}
                                    className={`reecosys-template-button button-style-primary-outline ${
                                      isMobilescreen ? "w100" : ""
                                    } `}
                                  >
                                    <span className="material-symbols-outlined">
                                      download
                                    </span>
                                    <p className="capitalize">
                                      {isMobilescreen ? "" : "Download "}
                                      {download_data.type}
                                    </p>
                                  </button>
                                </li>
                              ))}
                        </ul>
                      </div>
                    </div>
                  </div>
                </section>
              )
            } */}

            {/* {projectDetail?.gallery_data?.[0]?.image?.length > 0 && (
              <Gallery images={projectDetail?.gallery_data?.[0]?.image} />
            )} */}
            {/* {(projectDetail?.amenities_data?.length > 0 ||
              projectDetail?.amenities_tagline) && (
              <Amenities
                specifications={projectDetail.specifications || ""}
                url={projectDetail.virtual_data?.[0]?.url}
                amenities_title={projectDetail.amenities_title}
                amenities_tagline={projectDetail.amenities_tagline}
                amenities_data={projectDetail.amenities_data}
                image={projectDetail.amenities_images?.[0].image}
                otherImage={projectDetail?.gallery_data?.[0]?.image?.[0]?.image}
              />
            )} */}
            {/* {projectlist?.amenitiesData?.length > 0 && (
              <Amenitiesswiper amenities_data={projectlist} />
            )}
            {projectDetail?.construction_data?.image?.length > 0 && (
              <ConstructionUpdate projectDetail={projectDetail} />
            )}
            {projectDetail?.specifications?.length > 0 && (
              <Specifications specifications={projectDetail.specifications} />
            )} */}
            {/* {projectDetail.map_iframe != undefined &&
              projectDetail.map_iframe != "" && (
                <section
                  className="reecosys-section section-padding relative"
                  id="reecosys-project-detail-section-8"
                >
                  <div className="inner-flex inner-flex-medium">
                    <div className="main-container" id="project_location">
                      <div className="">
                        {projectDetail.location_title != undefined && (
                          <div className="inner-flex">
                            <div className="lcoation-view-grid-swati">
                              <div className="inner-flex inner-flex-medium">
                                <div className="section-title">
                                  <h2 className="uppercase">Location</h2>
                                </div>
                                <div className="inner-flex inner-flex-small">
                                  {projectDetail.location_tag_line && (
                                    <div className="inner-flex inner-flex-smallest">
                                      <div className="flex-row alc section-paragraph">
                                        <span
                                          className="locationIcon"
                                          style={{
                                            alignSelf: "start",
                                            paddingTop: "5px",
                                          }}
                                        >
                                          <img
                                            loading="lazy"
                                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/MapPinArea.svg"
                                            alt="Map ICon"
                                          />
                                        </span>
                                        <a
                                          href={projectDetail.map_slug}
                                          target="_blank"
                                          className="location-50"
                                        >
                                          <p
                                            className="gray-color  "
                                            dangerouslySetInnerHTML={{
                                              __html:
                                                projectDetail.location_tag_line,
                                            }}
                                          ></p>
                                        </a>
                                      </div>
                                    </div>
                                  )}
                                  <div className="flex-row alc locationFlex">
                                    <div className="inner-flex inner-flex-smallest ">
                                      <div className="flex-row alc section-paragraph">
                                        <span className="locationIcon">
                                          <img
                                            loading="lazy"
                                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/EnvelopeOpen.svg"
                                            alt="Email Icon"
                                          />
                                        </span>
                                        <p className="gray-color">
                                          <a
                                            href={`mailto:${projectDetail.project_contact_email}`}
                                            className="hover-color-link"
                                          >
                                            {
                                              projectDetail.project_contact_email
                                            }
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                    <div className="inner-flex inner-flex-smallest ">
                                      <div className="flex-row alc section-paragraph">
                                        <span className="locationIcon">
                                          <img
                                            loading="lazy"
                                            src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/PhoneCall.svg"
                                            alt="Call Icon"
                                          />
                                        </span>
                                        <p className="gray-color">
                                          <a
                                            href={`tel:${projectDetail.project_contact_no}`}
                                            className="hover-color-link"
                                          >
                                            {projectDetail.project_contact_no}
                                          </a>
                                        </p>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div className="flex-row flex-col-mob alc">
                                  <div
                                    className={`altura-btn altura-filled-btn-black ${
                                      isMobilescreen ? "w100" : ""
                                    } `}
                                  >
                                    <a
                                      // href="https://maps.app.goo.gl/fiBBova9ydoAXER29"
                                      href={projectDetail.map_slug}
                                      style={{ display: "block" }}
                                      target="_blank"
                                      className={`${
                                        isMobilescreen ? "w100" : ""
                                      } `}
                                    >
                                      <button
                                        className={`reecosys-template-button button-style-primary ${
                                          isMobilescreen ? "w100" : ""
                                        } `}
                                      >
                                        <span className="material-symbols-outlined">
                                          near_me
                                        </span>
                                        <p className=""> View on Map </p>
                                      </button>
                                    </a>
                                  </div>
                                  {staticProjectDetail?.proximityData !=
                                    undefined &&
                                    staticProjectDetail?.proximityData.length >
                                      0 && (
                                      <button
                                        className={`reecosys-template-button button-style-primary-outline ${
                                          isMobilescreen ? "w100" : ""
                                        } `}
                                        onClick={() => {
                                          dispatch(setProximityToggle(true));
                                        }}
                                      >
                                        <span className="material-symbols-outlined">
                                          location_city
                                        </span>
                                        <p>View Proximities</p>
                                      </button>
                                    )}
                                </div>
                              </div>
                              {projectDetail.map_iframe != undefined && (
                                <div>
                                  <div className="detail-location-iframe ">
                                    <iframe
                                      src={projectDetail.map_iframe}
                                      allowFullScreen=""
                                      loading="lazy"
                                      referrerPolicy="no-referrer-when-downgrade"
                                    ></iframe>
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        )}
                      </div>
                    </div>
                  </div>
                </section>
              )}

            <section className="inquiry-form-section section-padding">
              <div className="mini-container">
                <div
                  className="reecosys-section"
                  id="reecosys-detail-section-get-touch"
                >
                  <div className="inquiry_form_detail">
                    <div>
                      <div className="inner-flex inner-flex-medium">
                        <div className="inner-flex inner-flex-center inner-flex-smallest">
                          <div className="section-title">
                            <h2 className="semibold-fonts">Inquire Now</h2>
                          </div>
                          <div className="section-content">
                            <p>Fill your latest details.</p>
                          </div>
                        </div>
                        <div className=" project_detail_inquiry_form">
                          <form
                            id="inquiry_form_detail"
                            name="inquiry_form_detail"
                            className="inner-flex"
                            onSubmit={handleSubmit}
                          >
                            <div className="form_wrapper">
                              <div className="contact_lable">
                                <span className="material-symbols-outlined icon-form-control">
                                  person
                                </span>
                                <input
                                  id="client_name"
                                  name="client_name"
                                  type="text"
                                  className={`form-control form-control-iconpad ${
                                    inquiryObj.client_name
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  } ${
                                    errors.client_name
                                      ? "ng-invalid "
                                      : "ng-valid"
                                  } ${
                                    inquiryObj.client_name ? "ng-touched" : ""
                                  } ${
                                    formSubmitted &&
                                    (!inquiryObj.client_name ||
                                      errors.client_name)
                                      ? "error"
                                      : ""
                                  } `}
                                  value={inquiryObj.client_name}
                                  onChange={handleChange}
                                  tabIndex={1}
                                />
                                <label
                                  className="md-lable"
                                  htmlFor="client_name"
                                >
                                  Name
                                </label>
                                <div className="valid-icon-of-form">
                                  <img
                                    loading="lazy"
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                    alt=""
                                  />
                                </div>
                              </div>
                              <div className="contact_lable  relative">
                                <span className="material-symbols-outlined icon-form-control">
                                  dialpad
                                </span>
                                <input
                                  tabIndex={2}
                                  id="client_contact_no_display"
                                  name="client_contact_no_display"
                                  type="text"
                                  className={`form-control contact-form form-control-iconpad ${
                                    inquiryObj.client_contact_no_display
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  } ${
                                    formSubmitted &&
                                    (!inquiryObj.client_contact_no_display ||
                                      errors.client_contact_no_display)
                                      ? "error"
                                      : ""
                                  }
                                                                    ${
                                                                      !errors.client_contact_no_display &&
                                                                      inquiryObj
                                                                        .client_contact_no_display
                                                                        .length ===
                                                                        10
                                                                        ? "ng-valid"
                                                                        : "ng-invalid"
                                                                    } ${
                                                                      inquiryObj.client_contact_no_display
                                                                        ? "ng-touched"
                                                                        : ""
                                                                    }`}
                                  value={inquiryObj.client_contact_no_display}
                                  onChange={(e) => {
                                    handleChange(e);
                                  }}
                                  minLength="10"
                                  maxLength="10"
                                />
                                <label
                                  className="md-lable contact_code"
                                  htmlFor="contact_no"
                                >
                                  Mobile Number
                                </label>
                                <div className="valid-icon-of-form">
                                  <img
                                    loading="lazy"
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                    alt=""
                                  />
                                </div>
                                <div className="conatct_number_input">
                                  <div
                                    className="country_code_data"
                                    onClick={(event) => {
                                      setCountryFlag(true);
                                      event.stopPropagation();
                                    }}
                                    ng-click="country_code_click(); $event.stopPropagation();"
                                  >
                                    <div className="contact_country_flag">
                                      <img
                                        loading="lazy"
                                        src={inquiryObj.flag}
                                        alt="reecosys"
                                      />
                                    </div>
                                    <div>&nbsp;+{inquiryObj.country}</div>
                                    <div>
                                      <i
                                        className="fa fa-angle-down"
                                        aria-hidden="true"
                                      ></i>
                                    </div>
                                  </div>
                                </div>
                                <div
                                  className={`country_code_list_data ${
                                    countryFlag ? "active" : ""
                                  } `}
                                  onClick={(e) => e.stopPropagation()}
                                >
                                  <div className="search_c-code">
                                    <input
                                      type="text"
                                      value={search}
                                      onChange={(e) =>
                                        setSearch(e.target.value)
                                      }
                                      placeholder="Search"
                                    />
                                  </div>
                                  <ul>
                                    {countryList != undefined &&
                                      countryList.length > 0 &&
                                      countryList
                                        .filter(
                                          (item) =>
                                            item.phonecode
                                              .toString()
                                              .includes(search) ||
                                            item.nicename
                                              .toLowerCase()
                                              .includes(search.toLowerCase()),
                                        )
                                        .map((item, index) => (
                                          <li
                                            key={`${item.phonecode}-${item.nicename}-${index}`}
                                          >
                                            <div
                                              onClick={(e) => {
                                                e.stopPropagation();
                                                handleCountrySelect(
                                                  item.phonecode,
                                                  item.flag,
                                                );
                                              }}
                                            >
                                              <div>
                                                <img
                                                  src={item.flag}
                                                  alt="country"
                                                />
                                              </div>
                                              <span className="display_country_code">
                                                +{item.phonecode}
                                              </span>{" "}
                                              {item.nicename}
                                            </div>
                                          </li>
                                        ))}
                                  </ul>
                                </div>
                              </div>
                              <div className="contact_lable">
                                <span className="material-symbols-outlined icon-form-control">
                                  alternate_email
                                </span>
                                <input
                                  id="email_address"
                                  name="email_address"
                                  type="email"
                                  className={`form-control form-control-iconpad ${
                                    inquiryObj.email_address
                                      ? "ng-not-empty"
                                      : "ng-empty"
                                  }
                                                                     ${
                                                                       formSubmitted &&
                                                                       (!inquiryObj.email_address ||
                                                                         errors.email_address)
                                                                         ? "error"
                                                                         : ""
                                                                     }
                                                                     ${
                                                                       errors.email_address
                                                                         ? "ng-invalid"
                                                                         : "ng-valid"
                                                                     } ${
                                                                       inquiryObj.email_address
                                                                         ? "ng-touched"
                                                                         : ""
                                                                     }`}
                                  value={inquiryObj.email_address}
                                  onChange={handleChange}
                                  tabIndex={3}
                                />

                                <label
                                  className="md-lable"
                                  htmlFor="email_address"
                                >
                                  Email
                                </label>
                                <div className="valid-icon-of-form">
                                  <img
                                    loading="lazy"
                                    src="https://ik.imagekit.io/ol8mhbfe8/swati-procon/icon/valid-icon.svg"
                                    alt=""
                                  />
                                </div>
                              </div>

                              <div className="contact_lable commentbox">
                                <span className="material-symbols-outlined icon-form-control">
                                  chat_bubble
                                </span>
                                <textarea
                                  id="remarks"
                                  name="remarks"
                                  type="text"
                                  // className={`form-control form-control-iconpad ${
                                  //   inquiryObj.remarks
                                  //     ? "ng-not-empty"
                                  //     : "ng-empty"
                                  // } ${inquiryObj.remarks ? "ng-touched" : ""}`}
                                  className={`form-control form-control-iconpad ${
                                    inquiryObj.remarks
                                      ? "ng-not-empty ng-touched"
                                      : "ng-empty"
                                  }`}
                                  value={inquiryObj.remarks}
                                  onChange={handleChange}
                                  rows="1"
                                  tabIndex={4}
                                ></textarea>

                                <label className="md-lable" htmlFor="remark">
                                  Comments
                                </label>
                              </div>
                              <p style={{ width: "100%" }}>
                                By submitting this form, you agree to the{" "}
                                <a href="#" className="hover-color-link">
                                  Terms & Conditions
                                </a>{" "}
                                of NB Buildcon.
                              </p>
                              <div className="sunmit-project-btn">
                                <button
                                  className="reecosys-template-button button-style-primary"
                                  type="submit"
                                  tabIndex={5}
                                >
                                  <span className="material-symbols-outlined">
                                    send
                                  </span>
                                  {submitLoad ? (
                                    <p>Please Wait...</p>
                                  ) : (
                                    <p>Submit</p>
                                  )}
                                </button>
                              </div>
                            </div>
                          </form>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </section> */}
          </div>
        </div>

        {/* <div
          className={`click-overlay ${
            isAmenityOpen || isProximityOpen ? "active" : ""
          } `}
          onClick={() => {
            (dispatch(setAmenityToggle(false)),
              dispatch(setProximityToggle(false)));
          }}
        ></div> */}
        {/* <div className={`amenities_popup ${isAmenityOpen ? "active" : ""}`}>
          <div className="relative">
            <div
              className="amenities-close-icon"
              onClick={() => {
                dispatch(setAmenityToggle(false));
              }}
            >
              <span className="material-symbols-outlined">close</span>
            </div>
            <div className="all-amenities-grid-detail inner-flex inner-flex-medium">
              <div className="">
                <div className="section-title">
                  <h2>Amenities</h2>
                </div>
              </div>
              <div className="all-amenites-list">
                <ul>
                  {projectDetail.amenities_data &&
                    projectDetail.amenities_data.length > 0 &&
                    projectDetail.amenities_data.map((amenities, index) => (
                      <li key={index} className="flex-row alc">
                        <div className="amenities-icon ">
                          <img
                            src={amenities.icon}
                            loading="lazy"
                            alt={projectDetail.project_title}
                          />
                        </div>
                        <div className="amenities-text">
                          <p>{amenities.amenity}</p>
                        </div>
                      </li>
                    ))}
                </ul>
              </div>
            </div>
          </div>
        </div> */}
        {/* <div
          className={`amenities_popup proximities_popup ${isProximityOpen ? "active" : ""}`}
        >
          <div className="relative">
            <div
              className="amenities-close-icon"
              onClick={() => {
                dispatch(setProximityToggle(false));
              }}
            >
              <span className="material-symbols-outlined">close</span>
            </div>
            <div className="all-amenities-grid-detail inner-flex inner-flex-medium">
              <div className="">
                <div className="section-title">
                  <h2>Proximities</h2>
                </div>
              </div>
              <div className="proximity-list">
                <ul>
                  {staticProjectDetail?.proximityData &&
                    staticProjectDetail?.proximityData.length > 0 &&
                    staticProjectDetail?.proximityData.map(
                      (proximity, index) => (
                        <li key={index} className="flex-row  alc">
                          <div className="section-subtitle">
                            <h4>{proximity.minutes}</h4>
                          </div>
                          <div className="section-content">
                            <p>
                              Minutes drive to
                              {proximity.location}
                            </p>
                          </div>
                        </li>
                      ),
                    )}
                </ul>
              </div>
            </div>
          </div>
        </div> */}
        {/* <BottomStrip
          isAmenityActive={isAmenityOpen}
          isProximityActive={isProximityOpen}
          isMobilescreen={isMobilescreen}
          projectDetail={projectDetail}
        /> */}
      </>
    );
  } else {
    return <h1>Please Wait</h1>;
  }
}
